/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsColumn: {
  name: 'column';
  data: string;
} = {
  name: 'column',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H6Zm0 2h12v7H6V5Z" fill="currentColor"/></svg>`,
};
